import { BaseRestRepository } from './baseRestRepository';
import type { PublicLanguage } from '~/swagger/portal/Api';

const LANGUAGES_URL = '/api/public/languages';

export class TranslationsRepository extends BaseRestRepository {
  public async getLanguages(): Promise<PublicLanguage[]> {
    const response = await this.fetchWithAuth(LANGUAGES_URL);
    return this.getJsonResponse(response);
  }
}
